import { computed } from 'vue';
import { useAppAuthData } from '@/stores/app/authData';

const LEARN_MORE_LINK = '<a href="#" class="learn-more-preamble-link" data-beacon-article-sidebar="69e61d9e046d2c9de52c28f4">Learn more here</a>.';

export const getJobNavLabels = () => {
  const { isStandaloneJobNav: isStandalone, authData } = useAppAuthData();
  const { hrisName } = authData;
  const tooltipNoun = isStandalone ? 'published' : 'HRIS';
  const profileName = isStandalone ? 'published' : hrisName;

  return {
    draftLibraryDescription: isStandalone
      ? `<p>These profiles are not yet published. ${LEARN_MORE_LINK}</p>`
      : `<p>These profiles are not yet published to ${hrisName} or visible to connected systems. ${LEARN_MORE_LINK}</p>`,
    publishedLibraryDescription: isStandalone
      ? `<p>These profiles are published and available in your catalog. ${LEARN_MORE_LINK}</p>`
      : `<p>These profiles are active in ${hrisName} and visible to connected systems. ${LEARN_MORE_LINK}</p>`,
    architectureAlertUpdateLocation: isStandalone ? 'in JobNav' : 'in your HRIS',
    publishedSourceSystemName: isStandalone ? 'JobNav' : hrisName,
    flsaLinkedColumnLabel: 'Published',
    editorLinkedTooltipHris: `The ${tooltipNoun} profile you are viewing in the editor is linked to this draft profile`,
    editorLinkedTooltipDraft: `The draft profile you are viewing in the editor is linked to this ${tooltipNoun} profile`,
    unlinkConfirmBody: (hasDraft) => (
      hasDraft
        ? `This will remove the link between this draft profile and the ${profileName} profile.`
        : `This will remove the link to ${profileName} profile`
    ),
  };
};

export const useJobNavLabels = () => {
  const labels = computed(() => getJobNavLabels());

  return { labels };
};
